export const ACTIONS_OPENED = 'moreButton/ACTIONS_OPENED';

export const actionsOpened = payload => ({
  type: ACTIONS_OPENED,
  payload,
});
